// client/state/HelpEditMode.tsx
// Provider for help edit mode state

import React, { createContext, useContext, useState } from "react";

const Ctx = createContext<{enabled:boolean; set:(b:boolean)=>void}>({
  enabled:false,
  set:()=>{}
});

export function HelpEditModeProvider({children}:{children:React.ReactNode}) {
  const [enabled, set] = useState(false);
  return <Ctx.Provider value={{enabled,set}}>{children}</Ctx.Provider>;
}

export const useHelpEditMode = ()=>useContext(Ctx);
